/*
 * HB: running total on the Add to cart button, plus prices on paid
 * Infinite Options extras (e.g. "12" Sheet Cake - 60 Portions (+£130.00)").
 *
 * Total = selected variant price x quantity + any paid extras.
 * Extras are read from the data Infinite Options attaches to each option.
 * If an extra's price can't be read, it is left out and the button shows
 * the cake price only, so the button never shows a wrong total.
 * Display only: nothing here changes what goes into the cart.
 */
(function () {
  if (window.hbPriceTotal) return;
  window.hbPriceTotal = true;

  var IO = '#infiniteoptions-container';

  function money(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function jq() {
    return window.Shoppad && window.Shoppad.$ ? window.Shoppad.$ : null;
  }

  // Price of an Infinite Options element in pence, or 0.
  function ioPrice(el) {
    var $ = jq();
    if (!$ || !el) return 0;
    var d = $(el).data() || {};
    var raw = d.variantPrice;
    if (raw === undefined || raw === null || raw === '') return 0;
    var n = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
    return isFinite(n) && n > 0 ? Math.round(n * 100) : 0;
  }

  function ioMode(el) {
    var $ = jq();
    var d = $ && el ? $(el).data() || {} : {};
    return d.variantPriceMode || 'per_quantity';
  }

  function isLive(el) {
    if (!el || el.disabled) return false;
    var field = el.closest('[class^="spb-io-field"]');
    if (field && (field.hasAttribute('disabled') || getComputedStyle(field).display === 'none')) return false;
    return true;
  }

  // Selected paid extras: [{price, mode}]
  function selectedExtras() {
    var box = document.querySelector(IO);
    if (!box) return [];
    var out = [];
    box.querySelectorAll('select').forEach(function (s) {
      if (!isLive(s)) return;
      var opt = s.options[s.selectedIndex];
      var p = ioPrice(opt);
      if (p) out.push({ price: p, mode: ioMode(opt) });
    });
    box.querySelectorAll('input[type=checkbox], input[type=radio]').forEach(function (i) {
      if (!i.checked || !isLive(i)) return;
      var p = ioPrice(i);
      if (p) out.push({ price: p, mode: ioMode(i) });
    });
    return out;
  }

  // Show "(+£x)" after paid extras, once.
  function labelExtras() {
    var box = document.querySelector(IO);
    if (!box) return;
    box.querySelectorAll('option').forEach(function (o) {
      if (o.dataset.hbPriced) return;
      var p = ioPrice(o);
      if (!p) return;
      o.dataset.hbPriced = '1';
      if (o.textContent.indexOf('£') === -1) o.textContent = o.textContent.replace(/\s+$/, '') + ' (+' + money(p) + ')';
    });
    box.querySelectorAll('input[type=checkbox], input[type=radio]').forEach(function (i) {
      if (i.dataset.hbPriced) return;
      var p = ioPrice(i);
      if (!p) return;
      i.dataset.hbPriced = '1';
      var label = i.closest('label');
      if (label && label.textContent.indexOf('£') === -1) label.appendChild(document.createTextNode(' (+' + money(p) + ')'));
    });
  }

  function variantData(form) {
    var vs = document.querySelector('.product-information variant-selects') || document.querySelector('variant-selects');
    var json = vs && vs.querySelector('[type="application/json"]');
    var id = form && form.querySelector('[name=id]');
    if (!json || !id) return null;
    try {
      var list = JSON.parse(json.textContent);
      var vid = String(id.value);
      for (var k = 0; k < list.length; k++) if (String(list[k].id) === vid) return list[k];
    } catch (e) {}
    return null;
  }

  function update() {
    var btn = document.querySelector('.product-information .single-add-to-cart-button');
    if (!btn) return;
    var formId = (document.querySelector('.product-information input[name=quantity]') || {}).getAttribute
      ? document.querySelector('.product-information input[name=quantity]').getAttribute('form')
      : null;
    var form = formId ? document.getElementById(formId) : btn.closest('form');
    var v = variantData(form);
    // The total is drawn with CSS (::after) from a data attribute, so it never
    // becomes part of the button text that the theme or apps read and rewrite.
    var text = btn.querySelector('.single-add-to-cart-button--text');
    if (!text) return;
    if (!v || !v.available || btn.disabled) {
      text.removeAttribute('data-hb-total');
      return;
    }
    var qtyEl = document.querySelector('.product-information input[name=quantity]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var total = v.price * qty;
    selectedExtras().forEach(function (x) {
      total += x.mode === 'per_order' || x.mode === 'per_cart' ? x.price : x.price * qty;
    });
    text.setAttribute('data-hb-total', ' · ' + money(total));
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      labelExtras();
      update();
    }, 30);
  }

  function init() {
    var st = document.createElement('style');
    st.textContent = '.single-add-to-cart-button--text[data-hb-total]::after{content:attr(data-hb-total)}';
    document.head.appendChild(st);
    schedule();
    document.addEventListener('change', schedule, true);
    document.addEventListener('input', schedule, true);
    document.addEventListener('click', function () { setTimeout(schedule, 60); }, true);
    document.addEventListener('product:variant-change', function () { setTimeout(schedule, 60); });
    var mo = new MutationObserver(schedule);
    var watch = function () {
      var box = document.querySelector(IO);
      if (box) mo.observe(box, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'style'] });
      var btn = document.querySelector('.product-information .single-add-to-cart-button');
      if (btn) mo.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      return !!box;
    };
    if (!watch()) {
      var wait = new MutationObserver(function () { if (watch()) { wait.disconnect(); schedule(); } });
      wait.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { wait.disconnect(); }, 15000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/*
 * HB: mobile product pages (768px and below): the chat button is tucked away
 * until the shopper scrolls past Add to cart, so it doesn't sit on top of the
 * price and options.
 * (A collapsible delivery widget was tried here and removed on 17 Oct 2026:
 * that belongs in the HB Delivery app, so it can open itself when Add to cart
 * is pressed without a date.)
 */
(function () {
  if (window.hbProductUi) return;
  window.hbProductUi = true;
  var MQ = window.matchMedia('(max-width: 768px)');

  var ticking = false;
  function chatCheck() {
    ticking = false;
    var atc = document.querySelector('.product-information .single-add-to-cart-button');
    var tuck = false;
    if (atc && MQ.matches) tuck = atc.getBoundingClientRect().bottom > 0;
    document.documentElement.classList.toggle('hb-chat-tucked', tuck);
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    setTimeout(chatCheck, 80);
  }

  function init() {
    chatCheck();
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    if (MQ.addEventListener) MQ.addEventListener('change', chatCheck);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
